'use client'
import { defaultCountries, parseCountry, buildCountryData } from 'react-international-phone';

// To see which iso2 maps to which country, see
// https://github.com/goveo/react-international-phone/blob/master/src/data/countryData.ts
const getCustomCountries = (supportedCountriesForVerification) => {
    const customCountries = defaultCountries.map(parseCountry).map((country) => {
        if (country.iso2 === 'fr')
            country.format = '(.) .. .. .. ..';
        return buildCountryData(country);
    });
    if (supportedCountriesForVerification) {
        return customCountries.filter(([, iso2]) => supportedCountriesForVerification.includes(iso2));
    }
    return customCountries;
};

export { getCustomCountries };
